import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useTemplatesStudio } from 'api/useTemplatesStudio';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { EToasterStatus, showToast } from 'utils/showToast';

import DialogModal from 'components/DialogModal/DialogModal';

export const TemplatesStudioDeleteDialog: React.FC = () => {
  const { publisherId } = useParams();
  const { deleteTemplate } = useTemplatesStudio(publisherId);
  const { templateIdToDelete, setTemplateIdToDelete } =
    useTemplateStudioState();

  const handleDelete = () => {
    deleteTemplate.mutate(templateIdToDelete!, {
      onSuccess: () => {
        showToast({
          message: 'Template deleted successfully',
          status: EToasterStatus.SUCCESS
        });
      },
      onError: () => {
        showToast({
          message: 'Error deleting template',
          status: EToasterStatus.ERROR
        });
      },
      onSettled: () => {
        setTemplateIdToDelete(undefined);
      }
    });
  };

  return (
    <DialogModal
      isOpen={true}
      onOpenChange={(open: boolean) => {
        if (!open) setTemplateIdToDelete(undefined);
      }}
      title={'Delete Template'}
      description={
        'Are you sure you want to delete this template? This action cannot be undone and will permanently remove the template from your account.'
      }
      data-testid="TemplatesStudio-DeleteTemplateModal"
      modalActions={{
        onConfirm: {
          label: 'Delete',
          action: () => handleDelete(),
          variant: 'destructive',
          testId: 'TemplatesStudio-DeleteTemplateModal-confirm'
        },
        onClose: {
          label: 'Cancel',
          action: () => setTemplateIdToDelete(undefined),
          variant: 'link',
          testId: 'TemplatesStudio-DeleteTemplateModal-cancel'
        }
      }}
    />
  );
};
